import { render, staticRenderFns } from "./CardColorRatio.vue?vue&type=template&id=45f5e9de&scoped=true"
import script from "./CardColorRatio.vue?vue&type=script&lang=js"
export * from "./CardColorRatio.vue?vue&type=script&lang=js"
import style0 from "./CardColorRatio.vue?vue&type=style&index=0&id=45f5e9de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f5e9de",
  null
  
)

export default component.exports